var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBitcoinIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z",
    fill: "#9BA2BA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 6C11.4477 6 11 6.44772 11 7L10 7C8.89543 7 8 7.89543 8 9V11V12V13V15C8 16.1046 8.89543 17 10 17H11C11 17.5523 11.4477 18 12 18C12.5523 18 13 17.5523 13 17C14.6569 17 16 15.6569 16 14C16 13.2316 15.7111 12.5308 15.2361 12C15.7111 11.4692 16 10.7684 16 10C16 8.34315 14.6569 7 13 7C13 6.44772 12.5523 6 12 6ZM12 15H13C13.5523 15 14 14.5523 14 14C14 13.4477 13.5523 13 13 13H10V15H12ZM10 11H13C13.5523 11 14 10.5523 14 10C14 9.44772 13.5523 9 13 9H12H10V11Z",
    fill: "#9BA2BA"
  })));
}
export default SvgBitcoinIcon;